<template>
  <crud-modal
    :title="$t('modals.user.authorizationTitle')"
    action="create"
    :on-submit="submit"
    :on-close="() => $emit('close')"
    validation-scope="user"
  >
    <div class="font-sans text-gray-800">
      <div class="mb-4 text-lg font-semibold">
        {{ $t('modals.user.authorizationSubtitle') }}
      </div>
      <ul class="ml-4 list-disc list-inside">
        <li>{{ $t('modals.user.authorizationDefaultRole') }}</li>
        <li>{{ $t('modals.user.authorizationNoBilling') }}</li>
        <li>{{ $t('modals.user.authorizationNoInvoice') }}</li>
      </ul>
    </div>
  </crud-modal>
</template>

<script>
import CrudModal from '@/components/modals/crud-modal'

import ACTIVATE_AUTHORIZATION from '@/graphql/ActivateAuthorization.gql'

export default {
  components: { CrudModal },
  props: {
    companyId: {
      type: String,
      required: true
    }
  },
  methods: {
    async submit () {
      await this.$apollo.mutate({
        mutation: ACTIVATE_AUTHORIZATION,
        variables: {
          companyId: this.companyId
        }
      })
      window.location.reload()
    }
  }
}
</script>
